const {
  VUE_APP_API_BASE_URL,
  VUE_APP_CLIENT_ID,
  VUE_APP_LOGLEVEL,
  VUE_APP_USER_API_URL,
  VUE_APP_STOCK_API_URL,
  VUE_APP_TESFRICONFIGURATION_API_URL,
  VUE_APP_TESFRICONFIGURATION_SECUREKEY,
  VUE_APP_CLIENT_ENVIRONMENT_CODE,
  VUE_APP_AUTH_API_URL,
  VUE_APP_LOGISTICVARIANT_API_URL,
  NODE_ENV = ""
} = process.env;

const environment = NODE_ENV.toLowerCase();
const apiBaseUrl = VUE_APP_API_BASE_URL;
const clientId = VUE_APP_CLIENT_ID;
const clientEnvironmentCode = VUE_APP_CLIENT_ENVIRONMENT_CODE;
const logLevel = VUE_APP_LOGLEVEL;
const apiUrls = {
  user: VUE_APP_USER_API_URL,
  stock: VUE_APP_STOCK_API_URL,
  tesfriconfiguration: VUE_APP_TESFRICONFIGURATION_API_URL,
  auth: VUE_APP_AUTH_API_URL,
  logisticVariant: VUE_APP_LOGISTICVARIANT_API_URL
};

const tesfriConfigurationsecureKey = VUE_APP_TESFRICONFIGURATION_SECUREKEY;

export { environment, apiBaseUrl, clientId, apiUrls, logLevel, tesfriConfigurationsecureKey, clientEnvironmentCode };
